import { combineReducers } from "redux";
import { authReducer, forgotReducer } from "./authentication/reducers";
import ChangeLayoutMode from "./themeLayout/reducers";
import {
  employeeBasedStoreListReducer,
  exchangeModelDetailReducer,
  getBrandReducers,
  getEmployeeDetailReducers,
  getModelReducers,
  productTypeReducers,
} from "./common/reducers";
import { storeDashboardDataReducers } from "./dashboard/reducers";
import {
  exchangeDashboardReducers,
  approvalDetailsReducer,
  approvalListReducer,
  updateApprovalStatusReducer,
} from "./exchange/reducers";
import {
  approvedUnusedReducer,
  approvedUsedReducer,
  awaitingApprovalReducer,
  checkExceptionDiscountReducer,
  checkDiscountReducer,
  managerApprovalDetailsReducer,
  submitExceptionDiscountReducer,
  updateApprovalDataReducer,
} from "./manager/reducers";
import {
  miningDashboardCategoryDetailsReducer,
  miningDashboardDataReducer,
  miningAudioDataReducers,
  postMiningAudioDataReducer,
  storeListReducer,
  submitMiningAudioDataReducer,
  miningCategoryListReducer,
  miningListenHoursReducer,
} from "./mining/reducers";
import {
  financeDashboardReducer,
  financeHistoryReducer,
  financeDetailsReducer,
  financeUpdateApprovalStatusReducer,
} from "./finance/reducers";
import {
  employeeDiscountCheckReducer,
  employeeDiscountHistoryDetailsReducer,
  employeeDiscountHistoryReducer,
  employeeDiscountModelListReducer,
  employeeDiscountPurchaseHistoryReducer,
  employeeDiscountSubmitReducer,
  employeeDiscountWalletReducer,
} from "./employeeDiscount/reducers";
import {
  asmSalesDashboardReducer,
  getStoreRankingDataReducers,
} from "./ranking/reducers";
import { splDashboardReducer } from "./spl/reducers";
import { marketingExpensesDashboardReducer, storeMarketingImagesGalleryReducer } from "./marketing/reducers";

const rootReducers = combineReducers({
  // Base Reducers
  auth: authReducer,
  forgot: forgotReducer,
  ChangeLayoutMode,
  productType: productTypeReducers,
  getModel: getModelReducers,
  getEmployeeDetail: getEmployeeDetailReducers,
  exchangeModelDetail: exchangeModelDetailReducer,
  getBrands: getBrandReducers,
  employeeBasedStoreList: employeeBasedStoreListReducer,
  storeDashboardData: storeDashboardDataReducers,

  // SPL Dashboard Reducer
  splDashboardData: splDashboardReducer,
  marketingExpensesDashboardData: marketingExpensesDashboardReducer,
  storeMarketingImagesGalleryData: storeMarketingImagesGalleryReducer,

  // Ranking Reducers
  StoreRankingData: getStoreRankingDataReducers,
  asmSalesDashboardData: asmSalesDashboardReducer,

  // Finance Reducers
  financeDashboardData: financeDashboardReducer,
  financeHistoryData: financeHistoryReducer,
  financeDetailsData: financeDetailsReducer,
  financeUpdateApprovalStatusData: financeUpdateApprovalStatusReducer,

  // Employee Discount Reducers
  employeeDiscountModelList: employeeDiscountModelListReducer,
  employeeDiscountCheck: employeeDiscountCheckReducer,
  employeeDiscountWallet: employeeDiscountWalletReducer,
  employeeDiscountSubmit: employeeDiscountSubmitReducer,
  employeeDiscountHistory: employeeDiscountHistoryReducer,
  employeeDiscountHistoryDetails: employeeDiscountHistoryDetailsReducer,
  employeeDiscountPurchaseHistory: employeeDiscountPurchaseHistoryReducer,

  // Exchange Reducer
  exchangeDashboard: exchangeDashboardReducers,
  approvalList: approvalListReducer,
  approvalDetails: approvalDetailsReducer,
  updateApprovalStatus: updateApprovalStatusReducer,

  //Manger Discount Reducer
  awaitingApproval: awaitingApprovalReducer,
  approvedUnused: approvedUnusedReducer,
  approvedUsed: approvedUsedReducer,
  managerApprovalDetails: managerApprovalDetailsReducer,
  updateApprovalData: updateApprovalDataReducer,
  checkDiscount: checkDiscountReducer,
  checkExceptionDiscount: checkExceptionDiscountReducer,
  submitExceptionDiscount: submitExceptionDiscountReducer,

  // Data Mining Reducer
  miningDashboardData: miningDashboardDataReducer,
  miningDashboardCategoryDetails: miningDashboardCategoryDetailsReducer,
  miningAudioData: miningAudioDataReducers,
  postMiningAudioData: postMiningAudioDataReducer,
  submitMiningAudioData: submitMiningAudioDataReducer,
  storeList: storeListReducer,
  miningCategoryList: miningCategoryListReducer,
  miningListenHours: miningListenHoursReducer,
});

export default rootReducers;
